import ClassRegisterPage from './ducks/ClassRegisterPage.duck';

export default {
  ClassRegisterPage,
};
